/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import ReactApexChart from 'react-apexcharts';

import { get } from '../../helpers/api_helper';
import { buildDonutOptions, dashboardPalette } from './chartTheme';

function BigCommercePaymentMethodChart(props) {
  const { t, date } = props;

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [chartOptions, setChartOptions] = useState(null);
  const [chartSeries, setChartSeries] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/api/sales/reports/payments/bigcommerce?isoDay=${date}`);
        const labels = response.map((row) => row.payment_method || t('Unknown'));
        const series = response.map((row) => Number(row.cnt || 0));

        setChartOptions(buildDonutOptions({
          labels,
          series,
          colors: [
            dashboardPalette.primary,
            dashboardPalette.accent,
            dashboardPalette.secondary,
            dashboardPalette.rose,
            '#d9a441',
            '#4f6f52',
            '#7b6fd6',
            '#7e8aa2',
          ],
          tooltipFormatter: (val) => `${val} orders`,
          totalLabel: t('Orders'),
        }));
        setChartSeries(series);
      } catch (error) {
        toastr.error(t('Error fetching BigCommerce payment method data'));
      }
    };

    fetchData();
  }, [date, t]);

  return (
    <div className="dashboard-chart dashboard-chart--compact">
      {chartOptions && chartSeries && (
        chartSeries.length > 0 ? (
          <ReactApexChart options={chartOptions} series={chartSeries} type="donut" height={320} />
        ) : (
          <div className="text-center text-muted py-5">
            {t('No BigCommerce sales found for this day')}
          </div>
        )
      )}
      {chartOptions === null && (
        <div className="text-center">
          <span className="mdi mdi-loading mdi-spin fs-2" />
        </div>
      )}
    </div>
  );
}

BigCommercePaymentMethodChart.propTypes = {
  t: PropTypes.any,
  date: PropTypes.string.isRequired,
};

BigCommercePaymentMethodChart.defaultProps = {
  t: null,
};

export default connect(() => ({

}), {})(withTranslation()(BigCommercePaymentMethodChart));
